var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBellSolid(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 20,
    viewBox: "0 0 18 20",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.636 0a1.24 1.24 0 0 0-1.234 1.25V2c-2.815.578-4.935 3.102-4.935 6.125v.734c0 1.836-.667 3.61-1.87 4.985l-.285.324a1.268 1.268 0 0 0-.205 1.344c.197.449.64.738 1.126.738h14.805c.486 0 .925-.29 1.126-.738.2-.45.12-.977-.205-1.344l-.285-.324a7.568 7.568 0 0 1-1.87-4.985v-.734c0-3.023-2.12-5.547-4.935-6.125v-.75A1.24 1.24 0 0 0 8.636 0zm1.746 19.27a2.518 2.518 0 0 0 .721-1.77H6.168c0 .664.258 1.3.721 1.77a2.452 2.452 0 0 0 3.493 0z",
    fill: "#FFF",
    fillRule: "nonzero"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBellSolid);
export default __webpack_public_path__ + "static/media/bell-solid.130f2128.svg";
export { ForwardRef as ReactComponent };